import React from 'react'
import MuiTextField from '@mui/material/TextField'
import BaseDisplayItem, {
    BaseDisplayItemProps,
    DisplayItemBase,
} from '@/feature/DisplayItems/BaseDisplayItem'

interface Props extends BaseDisplayItemProps<string, DisplayItemBase> {
    onKeyPress?: (
        id: string | number,
        e: React.KeyboardEvent<HTMLInputElement>
    ) => void
}

class AutoIncrementField extends BaseDisplayItem<
    string,
    DisplayItemBase,
    HTMLInputElement
> {
    renderShow(): React.ReactNode {
        const props = this.props as Props
        return props.value ? props.value : ''
    }

    // Legacy component didn't have a separate edit UI, it just displayed the value.
    renderEdit(): React.ReactNode {
        return this.renderShow()
    }

    renderSearch(): React.ReactNode {
        const props = this.props as Props

        return (
            <MuiTextField
                size="small"
                fullWidth
                type="text"
                value={props.value ?? ''}
                onChange={(e) =>
                    props.changeValue?.(
                        props.item.id,
                        e.target.value,
                        props.item
                    )
                }
                onKeyPress={
                    props.onKeyPress
                        ? (e) => props.onKeyPress!(props.item.id, e)
                        : undefined
                }
            />
        )
    }
}

export default AutoIncrementField
